import {defineMessages} from 'react-intl';

export default defineMessages({
  VERISIGN_TITLE: {
    id: 'common.moreInfo.trustMessage.verisign.title',
    defaultMessage: 'Secure payment',
  },
  VERISIGN_INFO: {
    id: 'common.moreInfo.trustMessage.verisign.info',
    defaultMessage: 'We use SSL security technology to protect all personal information.',
  },
  LEGAL_INFO_TITLE: {
    id: 'LegalMessage.prices.title',
    defaultMessage: 'Prices',
  },
  LEGAL_INFO_SET_BY_SELLER: {
    id: 'LegalMessage.prices.setBySeller',
    defaultMessage: 'Prices are set by sellers.',
  },
  LEGAL_INFO_VARY_FACE_VALUE: {
    id: 'LegalMessage.prices.varyFaceValue',
    defaultMessage: 'Prices may vary from face value.',
  },
  LEGAL_INFO_FACE_VALUE: {
    id: 'LegalMessage.prices.FaceValue',
    defaultMessage: 'Face value: {amount} per ticket.',
  },
  LEGAL_INFO_SEVERAL_FACE_VALUE: {
    id: 'LegalMessage.prices.SeveralFaceValue',
    defaultMessage: 'Face value: ',
  },
  LEGAL_INFO_NO_FACE_VALUE: {
    id: 'LegalMessage.prices.NoFaceValue',
    defaultMessage: 'Face value has not been provided by the seller.',
  },
  LEGAL_INFO_INCLUDE_VAT: {
    id: 'LegalMessage.prices.includeVAT',
    defaultMessage: 'Prices include VAT.',
  },
  LEGAL_INFO_INCLUDE_INCLUDE_FEES: {
    id: 'LegalMessage.prices.includeFees',
    defaultMessage: 'Prices include fees.',
  },
  LEGAL_INFO_INCLUDE_ESTIMATED_FEES: {
    id: 'LegalMessage.prices.includeEstimatedFees',
    defaultMessage: 'Prices include estimated fees.',
  },
  LEGAL_INFO_EXCLUDE_FEES: {
    id: 'LegalMessage.prices.excludeFees',
    defaultMessage: 'Prices exclude fees.',
  },
  LEGAL_INFO_EXCLUDE_ESTIMATED_FEES: {
    id: 'LegalMessage.prices.excludeEstimatedFees',
    defaultMessage: 'Prices exclude estimated fees.',
  },
  LEGAL_INFO_NON_OFFICIAL_SELLER: {
    id: 'LegalMessage.prices.nonOfficialSeller',
    defaultMessage: 'Unless stated otherwise, the seller is not an official reseller for the event organizer.',
  },
});
